module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-1.df66edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-1.jpg
// module id = +niW
// module chunks = 1